<template>
  <div id="expecpage">
    <div id="expecinfo" class="space-y-3">
      <div id="PresentSalary" class="inline-block space-y-2">
        <p class="text-xl text-blue-400 font-medium">Present Salary :</p>
        <h3 class="text-md uppercase font-bold">
          {{ $store.state.Candidate.application.expectation.Present_salary }}
        </h3>
      </div>
      <div id="ExpextedSalary">
        <p class="text-xl text-blue-400 font-medium">Expected Salary:</p>
        <h3 class="text-md uppercase font-bold">
          {{ $store.state.Candidate.application.expectation.Expected_Salary }}
        </h3>
      </div>
      <div id="Heightincms">
        <p class="text-xl text-blue-400 font-medium">Height in cms :</p>
        <h3 class="text-md uppercase font-bold">
          {{ $store.state.Candidate.application.expectation.Height }}
        </h3>
      </div>
      <div class="">
        <div id="Weightinkg">
          <p class="text-xl text-blue-400 font-medium">Weight in Kgs :</p>

          <h3 class="text-md uppercase font-bold">
            {{ $store.state.Candidate.application.expectation.Weight }}
          </h3>
        </div>
      </div>
      <div id="disability">
        <p class="text-xl text-blue-400 font-medium">
          Details of Physical defetcs or disability :
        </p>
        <h3 class="text-md font-bold uppercase font-serif">
          <span v-if="$store.state.Candidate.application.expectation.Other">
            {{ $store.state.Candidate.application.expectation.Other }}
          </span>
          <span v-else>{{
            $store.state.Candidate.application.expectation.Other
          }}</span>
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
